import { VisitStatus } from 'store/visits/types';

/**
 * Repeat type enum for recurring visits
 */
export enum RepeatType {
  NONE = 'none',
  DAILY = 'daily',
  WEEKLY = 'weekly',
  WEEKDAY = 'weekday',
  MONTHLY_DAY_OF_MONTH = 'monthly_day_of_month',
  MONTHLY_DAY_OF_WEEK = 'monthly_day_of_week',
  CUSTOM = 'custom',
}

/**
 * Monthly recurrence mode — sent to BE for MONTHLY frequency. BE infers the
 * position / weekday / last-day flag from the visit's start date.
 */
export enum MonthlyMode {
  DAY_OF_MONTH = 'DAY_OF_MONTH',
  DAY_OF_WEEK = 'DAY_OF_WEEK',
}

/**
 * Days of the week for recurring visits
 */
export interface VisitRecurrenceDays {
  monday?: boolean;
  tuesday?: boolean;
  wednesday?: boolean;
  thursday?: boolean;
  friday?: boolean;
  saturday?: boolean;
  sunday?: boolean;
}

/**
 * Form data type for the When step
 * Matches the WhenStepData type from the schema
 */
export interface WhenStepFormData {
  visitStartDate: Date;
  visitEndDate?: Date | null;
  startTime: string;
  endTime?: string | null;
  duration?: number;
  useDuration?: boolean;
  repeatType: RepeatType;
  repeatEndDate?: Date | null;
  recurrenceDays?: VisitRecurrenceDays;
  isMultiDay?: boolean;
  visitDates?: Date[];
}

export enum HostingType {
  SELF = 'self',
  OTHER = 'other',
}

/**
 * Form data type for the Host step
 * Placeholder for future implementation
 */
export interface HostStepFormData {
  hostingType: HostingType;
  receiveInvitationCopy?: boolean | null;
  receiveCheckinNotifications?: boolean | null;
  additionalOrganizers?: string | null;
  floor: string;
  suite?: string | null;
  hostEmail?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

/**
 * Form data type for the Visit step
 */
export interface VisitStepFormData {
  visitorMode: VisitorMode;
  visitSummary: string;
  visitTypeId?: string;
  checkInInstructions?: string;
  noteForReception?: string;
  visitEntryOption?: string;
  acknowledgmentConfirmed?: boolean;
  email_opt_in?: boolean;
  sms_opt_in?: boolean;
  visitors: Visitor[];
  visitStatus?: VisitStatus;
}

/**
 * Individual visitor data structure
 */
export interface Visitor {
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
  companyName: string;
  photoUuid?: string;
  /** Present when mapped from API; omitted when creating a new visit after contact change */
  id?: string;
}

/**
 * Enum for visitor mode types
 */
export enum VisitorMode {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}

/**
 * Complete form data for all steps in CreateVisitFormV2
 */
export interface CreateVisitFormV2Data {
  when?: WhenStepFormData;
  host?: HostStepFormData;
  visit?: VisitStepFormData;
}

/**
 * Flat form values for the multi-step form
 */
export type CreateVisitFormV2Values = WhenStepFormData & HostStepFormData & VisitStepFormData;
